<template>
  <v-radio-group 
    v-model="Value" 
    :mandatory="false" 
    v-bind="$attrs"
  >
    <v-radio
      v-for="(radio, id) in radios"
      :key="id"
      :color="$vuetify.theme.currentTheme.primary"
      :checked="radio.checked"
      :radios="radios"
      :label="radio.label"
      :value="radio.value"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import { ednValue } from './mixins/ednValue'

export default {
  inheritAttrs: false,
  mixins:[ednValue],
  props: {
    radios: {
      type: Array,
      default: () => [],
    },
    value: null,
  },
  computed: {}
}
</script>
